import { render } from "./pending_payment.vue?vue&type=template&id=5317593e"
import script from "./pending_payment.vue?vue&type=script&lang=js"
export * from "./pending_payment.vue?vue&type=script&lang=js"

import "./pending_payment.vue?vue&type=style&index=0&id=5317593e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__